import AxiosService from '@/api/ApiBase';
import { FilterOptionsParams, FiltersService } from '@/types/service/filters.service';
import { LoadPlanEntity } from '@/types/export/load/plan/load-plan.entity';
import { LoadPlanFilters } from '@/types/export/load/plan/load-plan.filters';
import {
  LoadPlanInventoryItem,
  LoadPlanInventoryMovePayload,
} from '@/types/export/load/plan/load-plan.inventory.types';
import { OnHandEntity } from '@/types/on-hand/on-hand.entity';
import { VirtualSearchPayload, VirtualSearchResponse } from '@/types/virtual-search';

const LOAD_PLAN_BASE_URL = 'warehouse/export/loadplan';

// const LOAD_PLAN_BASE_URL = 'http://localhost:3000/api/export/loadplan';

class LoadPlanService implements FiltersService<LoadPlanEntity, LoadPlanFilters> {
  create(data: any) {
    return AxiosService.post(`${LOAD_PLAN_BASE_URL}/create`, data);
  }

  delete(loadPlanId: any) {
    return AxiosService.delete(`${LOAD_PLAN_BASE_URL}/delete/${loadPlanId}`);
  }

  update(data: any) {
    return AxiosService.put(`${LOAD_PLAN_BASE_URL}/update`, data);
  }

  getOneById(id: string) {
    return AxiosService.get<LoadPlanEntity>(`${LOAD_PLAN_BASE_URL}/get`, {
      params: {
        loadPlanId: id,
      },
    });
  }

  getFilterOptions<T>(params: Omit<FilterOptionsParams, 'limit'>) {
    return AxiosService.get<T>(`${LOAD_PLAN_BASE_URL}/filter/options`, {
      params: { ...params, limit: 100 },
    });
  }

  getOneByNumber(number: string) {
    return AxiosService.get<LoadPlanEntity>(`${LOAD_PLAN_BASE_URL}/get`, {
      params: {
        loadPlanNumber: number,
      },
    });
  }

  getFilteredItems(filters: LoadPlanFilters) {
    return AxiosService.post(`${LOAD_PLAN_BASE_URL}/filter`, filters);
  }

  virtualSearch(payload: VirtualSearchPayload<LoadPlanEntity>) {
    return AxiosService.post<VirtualSearchResponse<LoadPlanEntity>>(
      'warehouse/v2/export/loadPlan/search',
      payload
    );
  }

  move(payload: LoadPlanInventoryMovePayload) {
    return AxiosService.post<string>(`${LOAD_PLAN_BASE_URL}/inventory/move`, payload);
  }

  getAvailableInventoryItems(loadPlanId: string) {
    return AxiosService.get<OnHandEntity[]>(
      `${LOAD_PLAN_BASE_URL}/inventory/available/${loadPlanId}`
    );
  }

  getInventoryItems(customer?: string, onHandNumber?: string) {
    return AxiosService.get<LoadPlanInventoryItem[]>(`${LOAD_PLAN_BASE_URL}/inventory/get`, {
      params: { onHandNumber: onHandNumber, customer: customer },
    });
  }

  getLoadPlanDefaults() {
    return AxiosService.get<Pick<LoadPlanEntity, 'origin'>>(`${LOAD_PLAN_BASE_URL}/defaultValues`);
  }
}

export default new LoadPlanService();
